import PropTypes from 'prop-types';
var AllhomesAgencyModel = {
  id: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string]),
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  images: PropTypes.shape({
    profilePhoto: PropTypes.string,
    coverPhoto: PropTypes.string,
    coverPhotoLowResolution: PropTypes.string
  }),
  address: PropTypes.shape({
    street: PropTypes.string.isRequired,
    suburb: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired,
    lat: PropTypes.number,
    lng: PropTypes.number,
    divisionId: PropTypes.number,
    zoomLevel: PropTypes.number
  }),
  additionalOffices: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.shape({
      street: PropTypes.string.isRequired,
      suburb: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      postcode: PropTypes.string.isRequired
    })
  })),
  website: PropTypes.string,
  phone: PropTypes.string,
  logoBackgroundColour: PropTypes.string,
  memberships: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    description: PropTypes.string
  }))
};
export default AllhomesAgencyModel;